<template>
  <div>
    <div>
      <h1>歡迎進入KS-CONNECT管理系統</h1>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {
    $("#pageHead").text("歡迎");
  },
  created() {},
};
</script>

<style scoped>
h1 {
  font-size: 40px;
  margin-top: 20vw;
  text-align: center;
  color: #000;
}
</style>
